import { Post } from "../utils/http.js"

export function getIsOnline(params) {
  return Post("/api/mem/auth/isOnline", params)
}

export function getAccountInfo(params, config = {}) {
  return Post("/api/member/infoPoint", params, config)
}

export function logOut(params) {
  return Post("/api/mem/auth/logout", params)
}

export function bindYuu(params) {
  return Post("/api/mem/passport/bindYuu", params, { loading: true })
}

export function unBindYuu(params) {
  return Post("/api/mem/passport/unBindYuu", params, { loading: true })
}

export function queryBindYuu(params) {
  return Post("/api/mem/passport/queryBindYuu", params, { loading: true })
}
